/**
 * Chest COLLECT → hub pills hand-off (art wow pass, ui.md F4). The chest is banked when OPEN is tapped, on the end
 * screen, where there are no resource pills to fly into; the hub that follows is where they live. COLLECT parks the
 * gold here, and the next hub render starts its Gold pill that much lower, flies the painted
 * coins in from the middle of the screen and ticks the pills up to the real totals. Presentation only: the profile
 * already holds the real numbers, this just decides where the counters start.
 */
export interface LootFlight { gold: number }

/** A parked flight older than this is stale (the player went RETRY → another level) and is dropped. */
const MAX_AGE_MS = 120_000;
let pending: { loot: LootFlight; at: number } | null = null;

export function parkLootFlight(loot: LootFlight): void { pending = { loot, at: Date.now() }; }

/** The parked flight, once; null if there is none or it went stale. */
export function takeLootFlight(): LootFlight | null {
  const p = pending;
  pending = null;
  return p && Date.now() - p.at <= MAX_AGE_MS ? p.loot : null;
}
